import * as React from "react";

function WalletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 21 20",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    fillRule: "evenodd",
    d: "M3.166 6.462V5.004a2.5 2.5 0 012.5-2.5h9.167v3.75h3.333V17.92h-12.5a2.5 2.5 0 01-2.5-2.5V6.687 6.462zm10.417-.209H4.416v-1.25c0-.69.56-1.25 1.25-1.25h7.917v2.5zm-9.167 1.25v7.917c0 .69.56 1.25 1.25 1.25h11.25V7.503h-12.5zm7.917 4.666a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z",
    clipRule: "evenodd"
  }));
}

export default WalletIcon;